import WaiverContent from './WaiverContent'

export default WaiverContent
